import * as api from '@/api';

export async function shareLink() {
    const shortUrl  = await api.shortlinks.shortenURL(window.location.href)
    const shareData = {
        title: document.title,
        url: shortUrl.data.shortUrl
    };
    if(!navigator.share) return
    try {
        await navigator.share(shareData);
    } catch (error) {
        console.log(error)
        console.log(error.code)
        console.log(error.name)
    }
}